import { UPLOAD_SCENE, type UploadScene } from '@/app/constants';
import type { ImagePrompt } from '@/app/types';
import { uploadFile } from './upload-file';

export interface TempImageData {
  id: string;
  file: File;
  selectedImageBlob?: Blob;
  imageResolution: { width: number; height: number };
  selectedImageResolution?: { width: number; height: number };
  scene: UploadScene;
}

export const extractTempImageData = (prompt: ImagePrompt): TempImageData | null => {
  if (!prompt._tempFile) {
    return null;
  }

  return {
    id: prompt.sourceImage.replace('temp://', ''),
    file: prompt._tempFile,
    selectedImageBlob: prompt._tempSelectedImage,
    imageResolution: {
      width: prompt.sourceImageWidth || 0,
      height: prompt.sourceImageHeight || 0,
    },
    selectedImageResolution:
      prompt.selectedImageWidth && prompt.selectedImageHeight
        ? {
            width: prompt.selectedImageWidth,
            height: prompt.selectedImageHeight,
          }
        : undefined,
    scene: UPLOAD_SCENE.VIDU,
  };
};

export const uploadTempImages = async (
  tempImages: TempImageData[],
  onProgress?: (uploaded: number, total: number) => void,
): Promise<Map<string, { sourceUri: string; selectedUri?: string }>> => {
  const results = new Map<string, { sourceUri: string; selectedUri?: string }>();

  for (let i = 0; i < tempImages.length; i++) {
    const tempImage = tempImages[i];
    const { file, selectedImageBlob, imageResolution, selectedImageResolution, scene } = tempImage;

    const sourceResult = await uploadFile({
      file,
      width: imageResolution.width,
      height: imageResolution.height,
      scene,
    });

    if (sourceResult.error || !sourceResult.uri) {
      console.error('Failed to upload temp image:', sourceResult.error);
      continue;
    }

    let selectedUri: string | undefined;
    if (selectedImageBlob && selectedImageResolution) {
      const selectedResult = await uploadFile({
        file: selectedImageBlob,
        width: selectedImageResolution.width,
        height: selectedImageResolution.height,
        scene,
      });

      if (!selectedResult.error && selectedResult.uri) {
        selectedUri = selectedResult.uri;
      }
    }

    results.set(tempImage.id, {
      sourceUri: sourceResult.uri,
      selectedUri,
    });

    onProgress?.(i + 1, tempImages.length);
  }

  return results;
};
